/* eslint-disable react/prop-types */
import React from 'react';
import FormInputTagsItem from './FormInputTagsItem';
import StaticSearch from '../../search/StaticSearch';

export default props => {
  const searchProps = {
    allowSelectAll: false,
    filterBy: props.search.filterBy || 'value',
    showAll: true,
    sortBy: 'name',
    suggestions: props.search.suggestions,
  };

  return <FormInputTagsItem {...props} inputComponent={StaticSearch} inputProps={searchProps} />;
};
